import { lazy, Suspense } from 'react';
import { Outlet, Route } from 'react-router-dom';

import ErrorBoundaryContainer from '../../components/ErrorBoundaryContainer';
import Loading from '../../components/Loading';

import accountRouter from '../account';

const DasRPDashboardPageComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "dasrp-dashboard-page" */ '../../pages/dasrp-dashboard'
    ),
);

const dasRPDashboardRouter = (
  <Route path="dasrp-dashboard" element={<Outlet />}>
    <Route
      path=":projectId"
      element={
        <Suspense fallback={<Loading />}>
          <ErrorBoundaryContainer
            key="dasrp-dashboard"
            component={<DasRPDashboardPageComponent />}
          />
        </Suspense>
      }
    >
      {accountRouter()}
    </Route>
  </Route>
);

export default dasRPDashboardRouter;
